"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Loader = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Loader = function Loader(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.692 3c0 .92.724 1.667 1.616 1.667.892 0 1.615-.747 1.615-1.667S8.2 1.333 7.308 1.333 5.692 2.08 5.692 3zm-3.23 2.142c0 .79.62 1.43 1.384 1.43.765 0 1.385-.64 1.385-1.43 0-.789-.62-1.428-1.385-1.428s-1.384.64-1.384 1.428zm.692 5.238C2.517 10.38 2 9.849 2 9.19 2 8.533 2.517 8 3.154 8c.637 0 1.154.533 1.154 1.19 0 .658-.517 1.19-1.154 1.19zm1.154 2.382c0 .526.413.952.923.952s.923-.426.923-.952-.413-.953-.923-.953-.923.427-.923.953zm5.077 1.905c-.51 0-.923-.427-.923-.953s.413-.952.923-.952.923.426.923.952-.414.953-.923.953zm2.769-3.572c0 .394.31.714.692.714.383 0 .693-.32.693-.714a.704.704 0 00-.693-.714.704.704 0 00-.692.714zm1.385-3.572a.47.47 0 01-.462-.476.47.47 0 01.462-.476c.254 0 .461.213.461.476a.469.469 0 01-.461.476zM10.77 3.714a.47.47 0 00.46.476.469.469 0 00.462-.476.469.469 0 00-.461-.476.47.47 0 00-.462.476z",
    fill: "currentColor"
  }));
};

exports.Loader = Loader;
var _default = Loader;
exports.default = _default;